import FetchFactory from '../factory'

class TermsModule extends FetchFactory {
  private TERMS = '/terms/v1'

  /**
   * 법률 문서 목록 조회
   */
  getTermsList() {
    return this.call<APIResponse<TermsListItem[]>>('GET', `${this.TERMS}/legal`)
  }

  /**
   * 탈퇴 시 안내 문구 조회
   */
  getWithdrawalTerms() {
    return this.call<APIResponse<LegalContent>>(
      'GET',
      `${this.TERMS}/withdrawal`
    )
  }

  /**
   * 법률 문서 상세 조회
   */
  getTerms(termId: number) {
    return this.call<APIResponse<TermsContent>>(
      'GET',
      `${this.TERMS}/${termId}`
    )
  }
}

export default TermsModule
